import { PoolType } from '@/types/pool';

export const poolRateDisplay = (roi_rate?: string, term_months?: number): string => {
  return `${roi_rate || '--'}% / ${term_months || '--'} Months`;
};

/**
 * Format ROI rate for display
 * @param roiRate - ROI rate as string
 * @returns Formatted rate with % symbol
 */
export const formatROIRate = (roiRate: string): string => {
  return roiRate || '0';
};

export const POOL_TYPE_DISPLAY: Record<PoolType, string> = {
  [PoolType.EQUITY]: 'Equity',
  [PoolType.REFINANCE]: 'Refinancing',
};

export const isRefinancing = (poolType: PoolType): boolean => {
  return poolType === PoolType.REFINANCE;
};
